/* FREYD Editorial theme — small, dependency-free enhancements */
(() => {
  const F = window.FREYD || {};
  const S = F.strings || {};
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const fmt = F.moneyFormat || '${{amount}}';
    const n = Number(cents) / 100;
    const withSep = (v, dec, ts, ds) => {
      const [i, d] = v.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (d ? ds + d : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return withSep(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withSep(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSep(n, 0, '.', ',');
        default: return withSep(n, 2, ',', '.');
      }
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    const btn = $('[data-menu-toggle]');
    const menu = $('[data-mobile-menu]');
    if (!btn || !menu) return;
    const label = $('[data-menu-label]', btn);
    const open = () => {
      menu.hidden = false;
      requestAnimationFrame(() => menu.classList.add('is-open'));
      btn.setAttribute('aria-expanded', 'true');
      if (label) label.textContent = 'Close';
      const first = $('a', menu); if (first) first.focus();
    };
    const close = (restore = true) => {
      menu.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      if (label) label.textContent = 'Menu';
      setTimeout(() => { if (btn.getAttribute('aria-expanded') === 'false') menu.hidden = true; }, 260);
      if (restore) btn.focus();
    };
    btn.addEventListener('click', () => (btn.getAttribute('aria-expanded') === 'true' ? close() : open()));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') close(); });
    document.addEventListener('click', (e) => {
      if (btn.getAttribute('aria-expanded') === 'true' && !menu.contains(e.target) && !btn.contains(e.target)) close(false);
    });
    window.matchMedia('(min-width: 750px)').addEventListener('change', (m) => { if (m.matches && btn.getAttribute('aria-expanded') === 'true') close(false); });
  }

  /* ---------- Cart ---------- */
  const drawer = () => $('[data-cart-drawer]');
  let lastFocus = null;

  function setInert(on) {
    $$('body > *').forEach((el) => {
      if (el.tagName === 'SCRIPT' || (drawer() && el.contains(drawer()))) return;
      if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    });
  }

  function openDrawer() {
    const d = drawer(); if (!d) return false;
    lastFocus = document.activeElement;
    d.hidden = false;
    setInert(true);
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      d.classList.add('is-open');
      const panel = $('.drawer__panel', d);
      const target = $('[name="checkout"]', d) || $('[data-drawer-close].icon-btn', d) || panel;
      (target || panel).focus({ preventScroll: true });
    });
    return true;
  }

  function closeDrawer() {
    const d = drawer(); if (!d || d.hidden) return;
    d.classList.remove('is-open');
    setInert(false);
    document.documentElement.style.overflow = '';
    setTimeout(() => { if (!d.classList.contains('is-open')) d.hidden = true; }, 280);
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  function trapFocus(e) {
    const d = drawer();
    if (!d || d.hidden || e.key !== 'Tab') return;
    const f = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', $('.drawer__panel', d)).filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function renderCart(sectionHtml, count) {
    if (sectionHtml) {
      const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const fresh = $('[data-cart-body]', doc);
      if (fresh) $$('[data-cart-body]').forEach((b) => { b.innerHTML = fresh.innerHTML; });
    }
    if (typeof count === 'number') $$('[data-cart-count]').forEach((el) => { el.textContent = `(${count})`; });
  }

  async function changeLine(lineEl, qty) {
    const line = Number(lineEl.dataset.line);
    lineEl.classList.add('is-busy');
    try {
      const res = await fetch(`${F.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity: qty, sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || S.error);
      renderCart(data.sections && data.sections['cart-drawer'], data.item_count);
      const focusAfter = $(`[data-line="${line}"] [data-qty-change]`) || $('.drawer__panel [data-drawer-close]') || $('[data-cart-body] a, [data-cart-body] button');
      if (focusAfter) focusAfter.focus({ preventScroll: true });
    } catch (err) {
      lineEl.classList.remove('is-busy');
      const box = $('.cart-error', lineEl.closest('[data-cart-body]'));
      if (box) { box.textContent = err.message || S.error; box.hidden = false; }
    }
  }

  function initCart() {
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-cart-open]');
      if (opener && F.cartDrawer && drawer()) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
      const q = e.target.closest('[data-qty-change]');
      if (q) {
        const lineEl = q.closest('[data-line]');
        if (lineEl) { e.preventDefault(); changeLine(lineEl, Math.max(0, Number(q.dataset.qtyChange))); }
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
      trapFocus(e);
    });
  }

  /* ---------- Product ---------- */
  function initProduct(root) {
    const form = $('[data-product-form]', root);
    const jsonEl = $('[data-product-json]');
    if (!form || !jsonEl) return;
    const data = JSON.parse(jsonEl.textContent);
    const select = $('[data-variant-select]', form);
    const btn = $('[data-add-btn]', form);
    const btnLabel = $('[data-add-label]', form);
    const priceEl = $('[data-price]', root);
    const modelErr = $('[data-model-error]', form);
    const formErr = $('[data-form-error]', form);
    const leadImg = $('[data-lead-slide] img', root);
    const bar = $('[data-buy-bar]');
    const barBtn = bar && $('[data-buy-bar-btn]', bar);
    const barSub = bar && $('[data-buy-bar-sub]', bar);

    const current = () => {
      if (!select) { const id = Number($('input[name="id"]', form).value); return data.variants.find((v) => v.id === id); }
      return data.variants.find((v) => String(v.id) === select.value) || null;
    };

    function swapLead(v) {
      if (!leadImg || !v || !v.image) return;
      const base = v.image.replace(/([?&])width=\d+/, '$1').replace(/[?&]$/, '');
      const join = base.includes('?') ? '&' : '?';
      leadImg.srcset = [400, 600, 800, 1000, 1300, 1600].map((w) => `${base}${join}width=${w} ${w}w`).join(', ');
      leadImg.src = `${base}${join}width=1600`;
      leadImg.alt = v.image_alt || data.title;
    }

    function update(fromUser) {
      const v = current();
      if (select) {
        select.classList.remove('is-invalid');
        if (modelErr) modelErr.hidden = true;
      }
      if (formErr) formErr.hidden = true;
      if (!v) {
        btnLabel.textContent = S.selectModel;
        btn.disabled = false;
        if (barBtn) barBtn.textContent = S.selectModel;
        return;
      }
      const cmp = v.compare_at_price > v.price ? ` <s class="muted">${formatMoney(v.compare_at_price)}</s>` : '';
      priceEl.innerHTML = `${formatMoney(v.price)}${cmp}`;
      btn.disabled = !v.available;
      btnLabel.textContent = v.available ? `[+] ${S.add}` : S.soldOut;
      if (barBtn) { barBtn.textContent = v.available ? S.add : S.soldOut; barBtn.disabled = !v.available; }
      if (barSub) barSub.textContent = `${v.title} · ${formatMoney(v.price)}`;
      if (fromUser) {
        swapLead(v);
        const track = $('[data-gallery-track]', root);
        if (track && track.scrollLeft > 0) track.scrollTo({ left: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (select) select.addEventListener('change', () => update(true));
    update(false);

    function requireModel() {
      if (select && !select.value) {
        select.classList.add('is-invalid');
        if (modelErr) modelErr.hidden = false;
        select.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        select.focus({ preventScroll: true });
        return false;
      }
      return true;
    }

    form.addEventListener('submit', async (e) => {
      if (!requireModel()) { e.preventDefault(); return; }
      if (!F.cartDrawer || !drawer()) return; // fall back to normal form post -> /cart
      e.preventDefault();
      const v = current();
      if (!v || !v.available) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btnLabel.textContent = S.adding;
      try {
        const fd = new FormData(form);
        fd.append('sections', 'cart-drawer');
        fd.append('sections_url', window.location.pathname);
        const res = await fetch(`${F.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
        const out = await res.json();
        if (!res.ok || out.status) throw new Error(out.description || out.message || S.error);
        const cart = await (await fetch(`${F.routes.cart}.js`, { headers: { Accept: 'application/json' } })).json();
        renderCart(out.sections && out.sections['cart-drawer'], cart.item_count);
        btnLabel.textContent = S.added;
        openDrawer();
        setTimeout(() => update(false), 1400);
      } catch (err) {
        if (formErr) { formErr.textContent = err.message || S.error; formErr.hidden = false; }
        update(false);
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }
    });

    // Mobile buy bar
    if (bar && barBtn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        const hide = entry.isIntersecting;
        bar.classList.toggle('is-visible', !hide);
        bar.setAttribute('aria-hidden', hide ? 'true' : 'false');
        barBtn.tabIndex = hide ? -1 : 0;
      }, { rootMargin: '0px 0px -40px 0px' });
      io.observe(btn);
      const footer = $('.site-footer');
      if (footer) {
        new IntersectionObserver(([en]) => { if (en.isIntersecting) { bar.classList.remove('is-visible'); bar.setAttribute('aria-hidden', 'true'); barBtn.tabIndex = -1; } }).observe(footer);
      }
      barBtn.addEventListener('click', () => {
        if (!requireModel()) return;
        if (form.requestSubmit) form.requestSubmit(btn); else btn.click();
      });
    }
  }

  /* ---------- Gallery (mobile carousel) ---------- */
  function initGallery(root) {
    const track = $('[data-gallery-track]', root);
    const prev = $('[data-gallery-prev]', root);
    const next = $('[data-gallery-next]', root);
    const idx = $('[data-gallery-index]', root);
    if (!track || !prev || !next) return;
    const slides = $$('.gallery__slide', track);
    const pad = (n) => String(n).padStart(2, '0');
    const at = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const go = (i) => {
      const n = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[n].offsetLeft - track.offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    };
    const sync = () => {
      const i = at();
      if (idx) idx.textContent = pad(i + 1);
      prev.disabled = i <= 0;
      next.disabled = i >= slides.length - 1;
    };
    prev.addEventListener('click', () => go(at() - 1));
    next.addEventListener('click', () => go(at() + 1));
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(at() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(at() - 1); }
    });
    sync();
  }

  /* ---------- Signature showcase ---------- */
  function initShowcase() {
    const sections = $$('[data-showcase]');
    if (!sections.length) return;
    const ease = (t) => 1 - Math.pow(1 - t, 3);
    let active = new Set();
    let ticking = false;

    const frame = () => {
      ticking = false;
      const vh = window.innerHeight;
      active.forEach((sec) => {
        const el = $('[data-showcase-case]', sec);
        if (!el) return;
        const r = sec.getBoundingClientRect();
        // 0 when the section's top meets the viewport bottom, 1 when its centre reaches ~55% of the viewport
        const start = vh;
        const end = vh * 0.55 - r.height / 2;
        const p = Math.min(1, Math.max(0, (start - r.top) / (start - end)));
        el.style.setProperty('--p', ease(p).toFixed(4));
      });
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } };

    const enable = () => {
      if (reduceMotion.matches) {
        sections.forEach((s) => { const el = $('[data-showcase-case]', s); if (el) el.style.setProperty('--p', 1); });
        window.removeEventListener('scroll', onScroll);
        return;
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      frame();
    };

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) active.add(en.target); else active.delete(en.target); });
        onScroll();
      }, { rootMargin: '10% 0px 10% 0px' });
      sections.forEach((s) => io.observe(s));
    } else {
      active = new Set(sections);
    }
    enable();
    reduceMotion.addEventListener('change', enable);
  }

  /* ---------- Reveal ---------- */
  function initReveal() {
    const els = $$('.reveal');
    if (!els.length) return;
    if (reduceMotion.matches || !('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach((e) => io.observe(e));
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMenu();
    initCart();
    $$('[data-product]').forEach((root) => { initProduct(root); initGallery(root); });
    initShowcase();
    initReveal();
  });

  // Theme editor: re-init sections when they reload
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-product]', e.target).forEach((root) => { initProduct(root); initGallery(root); });
    initShowcase();
    $$('.reveal', e.target).forEach((el) => el.classList.add('is-in'));
  });
})();
